var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bubble"},[_c('div',{staticClass:"growSpacer"}),_c('b-button',{staticStyle:{"background":"none","color":"#dfdfdf","border":"none","font-size":"24px"},on:{"click":_vm.go}},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"growSpacer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }